import React, { useState } from 'react';
import { Box, Typography, Button, Paper, FormControl, Checkbox, MenuItem, Grid, Card, CardContent,Autocomplete, TextField, Popper, Chip} from '@mui/material';
import {Row, Col, message, DatePicker, Divider} from 'antd';
import axios from 'axios';
import { useEffect } from 'react';
import dayjs from 'dayjs';

import { ChartBar, ChartNoAxesCombined, ChartColumnIncreasing, ChartPie, ChartSpline, TrendingDown, TrendingUp, Activity } from 'lucide-react';




// import { DateRangePicker } from '@mui/x-date-pickers-pro';

// import { DatePicker } from '@mui/x-date-pickers';


import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import TreemapModule from 'highcharts/modules/treemap';
TreemapModule(Highcharts);

const LableChips = (value) =>{      
  return(value&&<Chip
            label={value?.charAt(0).toUpperCase() + value?.slice(1)}
            sx={{
              bgcolor: `${
                value.toLocaleString()=='Numeric'?'rgba(228,252,236)'
                :value.toLocaleString()=='Categorical'?'rgba(231,237,255)'
                :value.toLocaleString()=='Date Time'?'rgba(254,234,234)':'rgba(255,247,231)'}`,
              color:`${
                value. toLocaleString()=='Numeric'?'#166534'
                :value.toLocaleString()=='Categorical'?'#2e4eb5'
                :value.toLocaleString()=='Date Time'?'#9d2323':'#f59002'}`,
              borderRadius: '4px',
              fontFamily: 'monospace',
              fontSize: '0.875rem',
            }}
            >
            </Chip>
  )
}

const StatusPops = [
    {"key":'min',"value":'MIN',"bg":'#e3effe',"color":'#2e4eb5','icon':<TrendingDown size={18} />},
    {"key":'max',"value":'MAX',"bg":'#e4fcec',"color":'#166534','icon':<TrendingUp size={18} />},
    {"key":'mean',"value":'MEAN',"bg":'#f6efff',"color":'#6b21a8','icon':<Activity size={18} />},
    {"key":'median',"value":'MEDIAN',"bg":'#fff2e1',"color":'#9a3412','icon':<Activity size={18} />},
    {"key":'mode',"value":'MODE',"bg":'#feeaea',"color":'#9d2323','icon':<ChartBar size={18} />},
    {"key":'stdDev',"value":'STD DEV',"bg":'#e7edff',"color":'#2e4eb5','icon':<ChartNoAxesCombined size={18} />},
    {"key":'count',"value":'COUNT',"bg":'#f5f6f7',"color":'#2a3441','icon':<ChartColumnIncreasing size={18} />},
    {"key":'unique',"value":'UNIQUE',"bg":'#f5f8fa',"color":'#232e3f','icon':<ChartPie size={18} />},
    {"key":'skewness',"value":'SKEWNESS',"bg":'#fff7e7',"color":'#f59002','icon':<ChartSpline size={18} />},
    {"key":'kurtosis',"value":'KURTOSIS',"bg":'#ffcce0',"color":'#ff0066','icon':<ChartSpline size={18} />},
]

HighchartsMore(Highcharts);

export const VolumeMetrics = (props) => {
  const [loader, setloader] = useState(false)
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [AggregationMethod, setAggregationMethod] = useState(null);
  const [granularity, setGranularity] = useState(null);
  const [TopBottomLimit, setTopBottomLimit] = useState(null);
  const [VolumeMetricData, setVolumeMetricData] = useState(null);
  
  const GenerateTreeMapChart = (name) =>{
        Highcharts.chart(`${name}-container`, {
        series: [{
            type: 'treemap',
            name: 'VolumeMetrics',
            allowTraversingTree: true,
            alternateStartingDirection: true,
            dataLabels: {
                format: '{point.name}',
                style: {
                    textOutline: 'none'
                }
            },
            borderRadius: 3,
            nodeSizeBy: 'leaf',
            levels: [{
                level: 1,
                layoutAlgorithm: 'sliceAndDice',
                groupPadding: 3,
                dataLabels: {
                    headers: true,
                    enabled: true,
                    style: {
                        fontSize: '0.6em',
                        fontWeight: 'normal',
                        textTransform: 'uppercase',
                        color: 'var(--highcharts-neutral-color-100, #000)'
                    }
                },
                borderRadius: 3,
                borderWidth: 1,
                colorByPoint: true

            }, {
                level: 2,
                dataLabels: {
                    enabled: true,
                    inside: false
                }
            }],
            data:VolumeMetricData[`${name}`],
        }],
        title: {
            text: '',
            align: 'left'
        },
        credits: {
            enabled: false
        },
        subtitle: "",
        tooltip: {
            useHTML: true,
            backgroundColor: 'var(--dark2, #fff)',
            style: {
              color: 'var(--textPrimary, #664d4dff)',
            },
            pointFormat: '<b>{point.name}</b> : <b>{point.value:.2f}</b>'
        }
    });

  }

  const GetVolumeMetricsData = () => {
    setVolumeMetricData(null)
    setloader(true)
    axios({
      method:'POST',
      url:'/api/dataset_volume_metrics',
      data:{
        client_id:props?.SelectedProvider?.value,
        dataset_id:props?.SelectedProviderDataset?.value,
        period:granularity?.value,
        agg_method:AggregationMethod?.value,
        column:selectedColumn?.value,
        top_bottom_limit:TopBottomLimit?.value,
      }
    }).then(res=>{
        if (res?.data){
          if (res?.data?.message) {
            message.error(res?.data?.message, 3);
            setVolumeMetricData(res?.data?.data || null);
          }
          else {
          setVolumeMetricData(res?.data)
          }
        }
        setloader(false)
    }).catch(err=>{
        console.log(err);
        message.error(err?.response?.data?.error,3)
        setloader(false)
    })
  }



  useEffect(()=>{
    if (VolumeMetricData){
      GenerateTreeMapChart('top')
      GenerateTreeMapChart('bottom')
    }
  },[VolumeMetricData])


  useEffect(()=>{
    // Check if all required fields are selected before fetching data
    
    if (AggregationMethod?.value && selectedColumn?.value&&granularity?.value&&TopBottomLimit?.value){
      GetVolumeMetricsData()
    }
  },[AggregationMethod,selectedColumn,granularity,TopBottomLimit])

 


  return (
    <Box sx={{ p: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, color:'var(--textPrimary)' }}>
        <Box>

          <Typography variant="h2" sx={{ mb: 0.5 }}>
            Volume Metrics
          </Typography>
          <Typography variant="body1">
            Entity distribution patterns and concentration metrics
          </Typography>
        </Box>
      </Box>

      {/* Filter Controls */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, padding:'10px 0px 0px 15px' }}>
        <Grid container spacing={3}>
              <Grid size={6}>
                <FormControl size="small" sx={{ minWidth: 300, margin:'10px 5px ' }}>
                  <Autocomplete
                        className="data-select"
                        size='small'
                        disabled={loader}
                        disablePortal
                        id="disable-clearable"
                        disableClearable
                        fullWidth
                        onChange={(e,v) => {setSelectedColumn(v)}}
                        value={selectedColumn?.label}
                        options={props?.DatasetNumericColumns}
                        // renderInput={(params) => <TextField {...params} label='Choose a Column' />}
                        renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Choose a Column"
                              sx={{
                                    // Label color when disabled
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                      color: "#ff0000", // example: red label
                                    },
                                    // Border color when disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "var(--textPrimary)", // example: deep sky blue border
                                    },
                                    // Input text color when disabled
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      color: "#555555", // example: dark gray text
                                    },
                                    // Optional: background color when disabled
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "transparent",
                                    },
                                  }}

                              />)}

                    />
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl size="small" sx={{ minWidth: 200, margin:'10px 5px ' }}>
                    <Autocomplete
                        className="data-select"
                        size='small'
                        disabled={loader}
                        disablePortal
                        id="disable-clearable"
                        disableClearable
                        fullWidth
                        value={granularity}
                        defaultValue={granularity}
                        onChange={(e,v)=>{setGranularity(v)}}
                        getOptionDisabled={(option) => {
                                // Disable options based on the frequency value
                                if (props?.SelectedProviderDataset?.frequency == 'Weekly' && (option?.value === '1d')) {
                                    return true;
                                    }
                                if (props?.SelectedProviderDataset?.frequency == 'Monthly' && (option?.value === '1d' || option?.value === '1w')) {
                                    return true;
                                }
                                if (props?.SelectedProviderDataset?.frequency == 'Quarterly' && (option?.value === '1d'|| option?.value === '1w'|| option?.value === '1m')) {
                                    return true;
                                }
                                if (props?.SelectedProviderDataset?.frequency == 'Biannually' && (option?.value === '1d'|| option?.value === '1w'|| option?.value === '1m' || option?.value === '3m')) {
                                    return true;
                                }
                                if (props?.SelectedProviderDataset?.frequency == 'Yearly' && (option?.value === '1d'|| option?.value === '1w'|| option?.value === '1m' || option?.value === '3m' || option?.value === '6m')) {
                                    return true;
                                }
                                // Add more conditions based on the frequency value as needed
                                return false;
                            }}
                        options={
                          [{'label':'Last One Day',value:'1d'},
                          {'label':'Last One Week',value:'1w'},
                          {'label':'Last One Month',value:'1m'},
                          {'label':'Last Three Months',value:'3m'},
                          {'label':'Last Six Months',value:'6m'},
                          {'label':'Last One Year',value:'1y'},
                          {'label':'On Entire Data',value:'all'},
                          ]
                        }
                        renderInput={(params) => <TextField 
                                {...params} label='Choose a Time Period' 
                                sx={{
                                    // Label color when disabled
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                      color: "#ff0000", // example: red label
                                    },
                                    // Border color when disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "var(--textPrimary)", // example: deep sky blue border
                                    },
                                    // Input text color when disabled
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      color: "#555555", // example: dark gray text
                                    },
                                    // Optional: background color when disabled
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                              />}
                    />
                </FormControl> 
              </Grid>         
              <Grid size={6}>
                <FormControl size="small" sx={{ width: 200 , margin:'10px 10px '}}>
                  <Autocomplete
                      className="data-select"
                      size='small'
                      disablePortal
                      disabled={loader}
                      id="disable-clearable"
                      disableClearable
                      fullWidth
                      value={AggregationMethod}
                      defaultValue={AggregationMethod}
                      onChange={(e,v)=>{setAggregationMethod(v)}}
                      options={
                        [
                        // {'label':'Count',value:'count'},
                        {'label':'Sum',value:'sum'},
                        {'label':'Mean',value:'mean'},
                        {'label':'Min',value:'min'},
                        {'label':'Max',value:'max'},
                        // {'label':'Last Value',value:'last_value'},
                        // {'label':'First Value',value:'first_value'},
                        ]
                      }
                      renderInput={(params) => <TextField {...params} label='Choose a Aggregation'
                                  sx={{
                                    // Label color when disabled
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                      color: "#ff0000", // example: red label
                                    },
                                    // Border color when disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "var(--textPrimary)", // example: deep sky blue border
                                    },
                                    // Input text color when disabled
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      color: "#555555", // example: dark gray text
                                    },
                                    // Optional: background color when disabled
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                      
                      />}
                  />
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl size="small" sx={{ width: 230 , margin:'10px 10px '}}>
                  <Autocomplete
                      className="data-select"
                      size='small'
                      disablePortal
                      disabled={loader}
                      id="disable-clearable"
                      disableClearable
                      fullWidth
                      value={TopBottomLimit}
                      defaultValue={TopBottomLimit}
                      onChange={(e,v)=>{setTopBottomLimit(v)}}
                      options={
                        [
                        {'label':'Top & Bottom 3',value:3},
                        {'label':'Top & Bottom 5',value:5},
                        {'label':'Top & Bottom 10',value:10},
                        {'label':'Top & Bottom 15',value:15},
                        {'label':'Top & Bottom 20',value:20},
                        // {'label':'Top & Bottom 25',value:25},
                        // {'label':'Top & Bottom 30',value:30},
                        ]
                      }
                      renderInput={(params) => <TextField {...params} label='Choose a Top/Bottom limit'
                                  sx={{
                                    // Label color when disabled
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                      color: "#ff0000", // example: red label
                                    },
                                    // Border color when disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "var(--textPrimary)", // example: deep sky blue border
                                    },
                                    // Input text color when disabled
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      color: "#555555", // example: dark gray text
                                    },
                                    // Optional: background color when disabled
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                      
                      />}
                  />
                </FormControl>
              </Grid>
        </Grid>
      </Box>

      {/* Distribution Chart */}

      {/* Statistics */}
      {VolumeMetricData && (
        <Paper sx={{ p: 2, mb: 3 , paddingTop:'40px'}}>       
          <Grid container spacing={3}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} style={{paddingLeft:'25px'}}>
              <Typography variant="h3" style={{fontWeight:600}}>
                  Statistical Summary 
                </Typography>
                <Divider style={{borderColor:'var(--divider)',margin:'10px 0px 10px 0px'}}/>
              <div style={{display:'flex',justifyContent:'flex-start'}}>
                  <Box style={{paddingLeft:'0px'}}>
                    <Typography sx={{display:'flex',justifyContent:'flex-start', padding:'0px 0px 15px 0px'}}>
                      <Typography variant='h3' style={{fontWeight:600,paddingRight:'10px'}}>
                        {selectedColumn?.label} - 
                      </Typography> {LableChips(selectedColumn?.type)}
                    </Typography>
                </Box>
              </div>

              {/* Map through stat cards if data exists */}
              {selectedColumn && (
                <Row gutter={[8,8]}>
                  {StatusPops.filter(item=>selectedColumn[item.key] && selectedColumn[item.key]!="N/A").map(item=>
                      <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={4}>
                          <Card style={{
                            padding:'15px',
                            borderRadius:'10px',
                            borderColor:`transparent`,
                            backgroundColor:`${item.bg}`,
                            color:`${item.color}`
                          }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                  <Typography variant="h6">{item.value}</Typography>
                                  <Typography variant="body2">
                                    {selectedColumn['column']!="date" && item.icon}
                                  </Typography>
                              </Box>
                              <Typography variant="h4" style={{paddingTop:'5px',fontWeight:500}}>
                                    {selectedColumn[item.key]?.toLocaleString() || 'N/A'}
                              </Typography>
                        </Card>
                      </Col>
                    )
                  }
                </Row>
              )}
            </Col>
          </Grid>
        </Paper>
      )}

      {/* Volume metric Graphs */}
      <Paper sx={{ p: 3 }}>
        {VolumeMetricData&&<Row gutter={[16,16]}>
          <Col span={24}>
            <Typography variant="h2" sx={{ mb: 1 }}>
              Top {TopBottomLimit?.value} Volume Metrics
            </Typography>
            <div id='top-container'></div>
          </Col>
          <Col span={24}>
          <Typography variant="h2" sx={{ mb: 1 }}>
              Bottom {TopBottomLimit?.value} Volume Metrics
            </Typography>
            <div id='bottom-container'></div>
          </Col>
        </Row>}
        {!loader && !VolumeMetricData && AggregationMethod?.value&&selectedColumn?.value && granularity?.value && TopBottomLimit?.value &&
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
              <Typography variant="h4" color="textSecondary">
                No data available for the selected filters.
              </Typography>
            </Box>
        }
        {
          loader && 
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
            <Typography variant="h4" color="textSecondary">
              Loading data...
            </Typography>
          </Box>
        }
        {
          (!loader && !VolumeMetricData &&(!AggregationMethod?.value || !selectedColumn?.value || !granularity?.value || !TopBottomLimit?.value)) &&
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
            <Typography variant="h4" color="textSecondary">
              Please select filters to view the Volume metrics chart.
            </Typography>
          </Box>
        }

      </Paper>
    </Box>
  );
};

export default VolumeMetrics;


